import { render, staticRenderFns } from "./CardResult.vue?vue&type=template&id=27c2ee96&scoped=true&"
import script from "./CardResult.vue?vue&type=script&lang=js&"
export * from "./CardResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2ee96",
  null
  
)

export default component.exports